import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {dynamicFormComponents, dynamicFormServices} from './index';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {CalendarModule} from 'primeng/calendar';
import {ChipsModule} from 'primeng/chips';
import {FileUploadModule} from 'primeng/fileupload';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SelectButtonModule} from 'primeng/selectbutton';
import {CheckboxModule} from 'primeng/checkbox';
import {AccordionModule} from 'primeng/accordion';
import {ChartModule,} from 'primeng/chart';
import {VirtualScrollerModule} from 'primeng/virtualscroller';
import {SharedModule} from '../shared.module';
import {DynamicFormComponent} from './dynamic-form.component';
import {CoreModule} from '../../core/core.module';
import {ClickOutsideModule} from 'ng-click-outside';
import {FileUploadComponent} from './components/file-upload/file-upload.component';
import {LayoutModule} from '../../layout/layout.module';
import {DynamicFormModalComponent} from './components/dynamic-form-modal/dynamic-form-modal.component';
import {DynamicFormTableComponent} from './components/dynamic-form-table/dynamic-form-table.component';
import {UploadedFileDetailsComponent} from '@ispm/dynamic-form/components/uploaded-file-details/uploaded-file-details.component';
import {DynamicTabComponent} from '@ispm/dynamic-form/components/dynamic-tab-modal/dynamic-tab.component';
import {GroupTableComponent} from '@ispm/dynamic-form/components/group-table/group-table.component';
import {WidgetItemComponent} from '@ispm/dynamic-form/components/widget-item/widget-item.component';
import {PriorityTableComponent} from '@ispm/dynamic-form/components/priority-table/priority-table.component';
import {ItemsListComponent} from '@ispm/dynamic-form/components/items-list/items-list.component';
import {
  ChartItemDataComponent,
  ChartWidgetComponent,
  GenericLineChartComponent
} from '@ispm/dynamic-form/components/chart';
import {DerivedFieldComponent} from '@ispm/dynamic-form/components/derived-field/derived-field.component';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';
import {FilterTypesPipe} from './pipe/filter-types.pipe';
import {ExcludeIncludePipe} from './pipe/exclude-include.pipe';
import {DynamicFormTabsComponent} from '@ispm/dynamic-form/components/dynamic-form-tabs/dynamic-form-tabs.component';
import {DynamicFormDrawersComponent} from './components/dynamic-form-drawers/dynamic-form-drawers.component';
import {SummaryTableComponent} from "@ispm/dynamic-form/components/summary-table/summary-table.component";
import {LogiEmbedVisualComponent} from "@ispm-client/modules/analytics/component/logi-embed-visual.component";
import {ToggleButtonModule} from "@wuitk/angular/components/togglebutton";
import {TooltipModule} from "@wuitk/angular/components/tooltip";
import {DynamicFormPaginationComponent} from './components/dynamic-form-pagination/dynamic-form-pagination.component';
import {CommonModule as WuitkCommonModule} from '@wuitk/angular/components/common';
import {MultiselectModule} from '@wuitk/angular/components/multiselect';
import {TokenModule} from '@wuitk/angular/components/token';
import {MultiSelectComponent} from '@ispm/dynamic-form/components/multi-select/multi-select.component';


@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        AutoCompleteModule,
        LayoutModule,
        ChipsModule,
        SelectButtonModule,
        CalendarModule,
        ClickOutsideModule,
        RadioButtonModule,
        AccordionModule,
        // DataScrollerModule,
        CheckboxModule,
        FileUploadModule,
        AggregatorModule,
        VirtualScrollerModule,
        ChartModule,
        ChartModule,
        ToggleButtonModule,
        TooltipModule,
        WuitkCommonModule,
        MultiselectModule,
        TokenModule
    ],
    declarations: [...dynamicFormComponents, FileUploadComponent, DynamicFormModalComponent, DynamicFormTableComponent, UploadedFileDetailsComponent,
        DynamicTabComponent, GroupTableComponent, SummaryTableComponent, PriorityTableComponent, ItemsListComponent, DerivedFieldComponent, MultiSelectComponent, FilterTypesPipe, ExcludeIncludePipe, DynamicFormTabsComponent, DynamicFormDrawersComponent, ChartWidgetComponent, ChartItemDataComponent, GenericLineChartComponent, LogiEmbedVisualComponent, DynamicFormPaginationComponent],
    exports: [...dynamicFormComponents, FileUploadComponent, UploadedFileDetailsComponent, DynamicFormTableComponent, DynamicTabComponent, PriorityTableComponent, ItemsListComponent, DerivedFieldComponent, ChartWidgetComponent, ChartItemDataComponent, GenericLineChartComponent, SummaryTableComponent, LogiEmbedVisualComponent, MultiSelectComponent],
    entryComponents: [DynamicFormComponent, DynamicFormModalComponent, DynamicFormTableComponent, UploadedFileDetailsComponent,
    DynamicTabComponent, WidgetItemComponent, GroupTableComponent, SummaryTableComponent, PriorityTableComponent, ItemsListComponent, DerivedFieldComponent, DynamicFormTabsComponent, DynamicFormDrawersComponent,ChartWidgetComponent, ChartItemDataComponent, GenericLineChartComponent,LogiEmbedVisualComponent, DynamicFormPaginationComponent, MultiSelectComponent],
    providers: [...dynamicFormServices]
})
export class DynamicFormModule { }
